import { earlyRequestUserAttributes } from 'frontend-preferences-client/quickFetch';
import { MARKETING_DISCOVERY_UTILS, USER_ATTRIBUTES } from '../constants';
export function earlyMarketingDiscoveryUtilsUserAttributeRequester() {
  earlyRequestUserAttributes(Object.values(USER_ATTRIBUTES), MARKETING_DISCOVERY_UTILS);
}